const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const ScrollNotification = require("../components/scroll-notification");
//Include this file in bot.js and follow examples for other modules. The questions will be rendered in the server side -Rich

class PharmacyModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `pharmacy-module ${cssVariableKey}`);
    // this.elContainer.addELM(new Provider({ data: value }));
    this.contentHash = {};
    this.typingIndicator = null;
  }

  handle(type, value, reference) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;

    // this.elContainer.innerHTML = "";
    //this.elContainer.addELM(new Provider({ data: value }));

    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      const sTo = this.elContainer.offsetTop;
      Scroller.smoothScrollTo(sTo + _elm.getELM().offsetTop, 200, () => {});
    }
  }

  mapFormat(value) {
    return new Block({ 
      data: value.values//, 
      // answer: "pharmacy-value" 
    });
  }

  handleOnMessage(value) {
    let component = null;

    if (value.format === "empty") return null;

    if ((value.values || []).ignoreSuggestions) return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];
      const question = this.contentHash[identifier][1];

      if ((value.values || {}).text) {
        value.values.text = value.values.text.replace(/,/g, ';');
      }

      question.updateAnswer(value.values, this.clearAfterId.bind(this));
    } else if (!this.contentHash[identifier]) {
      component = this.mapFormat(value);
      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
        identsplit = (identifier || "").split("suggestions/");
        identifier = identsplit[0] + identsplit[1];
        component = this.contentHash[identifier][1];
        if (
          value.continue === false &&
          component._option._element.updateSuggestions
        ) {
          this.typingIndicator = null;
          component._option._element.updateSuggestions(
            (value.values || []).suggestions, 
            {
                sendObject: true // Send the whole object not just the name
            }
          );
          return;
        }
      } else {
        this.contentHash[identifier] = [
          Object.keys(this.contentHash).length,
          component
        ];
      }
    } else {
      component = (this.contentHash[identifier] || [])[1];

      if (!component) {
        component = this.mapFormat(value);
        this.contentHash[identifier] = [
          Object.keys(this.contentHash).length,
          component
        ];
      }
    }

    if (value.status === "typing" || value.id.indexOf("/") === -1) {
      this.typingIndicator = component;
    }

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;

    this.parent && this.parent.clearAfterId && this.parent.clearAfterId(this.value.id);
  }

  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);
    }
  }
}

module.exports = PharmacyModule;
